import {HttpServices} from "../Helpers";
import {PHP_V13_URL} from "../api/urls";

export const GetAllTasks = async ({
  limit,
  page,
  order_by,
  order,
  filters,
}) => {
  return await HttpServices.get(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/task/users/list`,
    {
      params: {
        ...filters,
        limit,
        page,
        order_by,
        order,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};
export const GetAllScorecardDecisions = async ({
  limit,
  page,
  order_by,
  order,
}) => {
  return await HttpServices.get(
    `${PHP_V13_URL}/api/recruiter/scorecard/${process.env.REACT_APP_VERSION_API}/job/candidate/decisions`,
    {
      params: {
        limit,
        page,
        order_by,
        order,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const GetTaskById = async ({uuid}) => {
  return await HttpServices.get(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/task/users/view`,
    {
      params: {
        uuid,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const GetTaskBySlug = async ({slug, company_uuid}) => {
  return await HttpServices.get(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/task/users/${slug}`,
    (company_uuid && {
      headers: {
        "Accept-Company": company_uuid,
      },
    }) ||
      undefined
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const CreateTask = async (body) => {
  return await HttpServices.post(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/task/users`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const UpdateTask = async (body) => {
  return await HttpServices.put(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/task/users`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const UpdateTaskStatus = async (body) =>
  await HttpServices.put(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/task/users/status`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);

export const CancelScorecardTask = async (body) =>
  await HttpServices.delete(
    `${PHP_V13_URL}/api/recruiter/scorecard/${process.env.REACT_APP_VERSION_API}/job/candidate/cancel`,
    {data: body}
  )
    .then((data) => data)
    .catch((error) => error.response);

export const DeleteTask = async (params) => {
  return await HttpServices.delete(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/task/users`,
    {
      params,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const GetAllTriggerTaskTypes = async ({
                                                 have_candidate_relation = false,
                                                 with_scorecard = false
                                             }) => {
    // Build the params object conditionally
    const params = {have_candidate_relation};

    if (with_scorecard) {
        params.with_scorecard = with_scorecard;
    }

    return await HttpServices.get(
        `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/task/users/types`,
        {params}
    )
        .then((data) => data) // Keep this intact
        .catch((error) => error.response); // Keep this intact
};

export const GetAllCandidatesSearchDBNew = async ({
  use_for = "dropdown",
  limit = 12,
  is_include = true,
  // date_filter_type = "default",
  page = 1,
  params,
  arrays = {},
  search,
  isDropdown,
  with_than,
}) => {
  let queryString = "";
  Object.keys(arrays).forEach((key) => {
    if (arrays[key])
      arrays[key].forEach((value) => {
        queryString = `${queryString}&${key}=${value}`;
      });
  });

  return await HttpServices.get(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/pre-approval`,
    {
      params: {
        ...params,
        with_than,
        use_for,
        is_include,
        page,
        limit,
        // date_filter_type,
        ...arrays,
        ...(isDropdown && search && {candidate_name: search}),
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const GetAllSetupsTaskStatuses = async ({
  limit,
  page,
  search,
  status,
  use_for = "dropdown",
  other_than,
  with_than,
  company_uuid,
}) =>
  await HttpServices.get(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/task_status`,
    {
      params: {
        with_than,
        other_than,
        limit,
        page,
        query: search,
        status,
        use_for,
      },
      headers:
        (company_uuid && {
          "Accept-Company": company_uuid,
        }) ||
        undefined,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

export const MarkTaskAsCompleted = async ({uuid}) =>
  await HttpServices.get(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/task/users/mark-as-completed`,
    {
      params: {uuid},
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
